import { createEmptyLogsAndVars, dwReportError, recordVariable } from "../diagnostics/clientErrors";
export const toUseraddressJson = (data) => {
    const json = JSON.stringify(data);
    return json;
};
export const fromUseraddressJson = (json) => {
    try {
        return JSON.parse(json);
    }
    catch (ex) {
        const logsAndVars = createEmptyLogsAndVars("useraddressJsonConver:fromUseraddressJson");
        recordVariable(logsAndVars, "json (param)", json);
        dwReportError(null, undefined, ex, { logsAndVars });
        return undefined;
    }
};
export const createStorageJson = (address, useraddress, role, registered) => {
    const useraddressData = {
        address: address,
        useraddress: {
            address: useraddress,
            role: role,
            registered: registered,
        },
    };
    return useraddressData;
};
